import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'

const menuItems = [
  { id: 'monitor', label: '直播监控', path: '/monitor' },
  { id: 'schedule-rules', label: '预约规则', path: '/schedule-rules' },
  { id: 'settings', label: '系统设置', path: '/settings' },
]

export default function MobileBottomNav() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 border-t border-[var(--structural-border)] bg-[var(--console-ink)] pb-[env(safe-area-inset-bottom)] lg:hidden">
      <div className="grid h-[72px] grid-cols-3">
        {menuItems.map((item) => (
          <NavLink
            key={item.id}
            to={item.path}
            className={({ isActive }) =>
              cn(
                'flex min-h-11 flex-col items-center justify-center gap-1.5 text-[11px] transition-colors',
                isActive ? 'font-semibold text-[var(--action-blue)]' : 'text-[var(--text-muted)]'
              )
            }
          >
            {({ isActive }) => (
              <>
                <span
                  aria-hidden="true"
                  className={cn(
                    'h-2 w-2 rounded-full',
                    isActive ? 'bg-[var(--action-fill)]' : 'bg-[var(--border-control)]'
                  )}
                />
                <span>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
